export const createComment = ({
  table_id = 0,
  table_name = '',
  comment = '',
  score = undefined,
  subject = undefined,
  clientID = '',
  status = '',
  comment_id = 0,
  user_name = '',
  created = ''
} = {}) => {
  return {
    table_id,
    table_name,
    comment,
    score,
    subject,
    clientID,
    status,
    comment_id,
    user_name,
    created
  }
};
